import { ThemeOptions } from '@mui/material/styles'
import { color, size, space } from '../styles/'
import { lighten } from 'polished'

const colorLevels = (colorSource: string) => {
   const main = colorSource
   const light = lighten(0.1, colorSource)
   const dark = lighten(-0.1, colorSource)
   const contrastText = '#fff'
   return { main, light, dark, contrastText }
}

const Theme: ThemeOptions = {
   palette: {
      primary: colorLevels(color.green),
      secondary: colorLevels(color.violet),
      error: colorLevels(color.red),
      warning: colorLevels(color.yellow),
      info: colorLevels(color.blue),
      success: colorLevels(color.aqua),
   },
   typography: {
      fontFamily: "'Circular Std', Helvetica, Arial, sans-serif",
      fontWeightBold: 700,
      fontWeightMedium: 400,
      fontWeightRegular: 300,
   },

   components: {
      MuiButton: {
         styleOverrides: {
            root: ({ theme }) => ({
               fontSize: size.m,
               borderRadius: size.xxl,
               padding: `${space.xs} ${space.l}`,
               whiteSpace: 'nowrap',
               fontWeight: 700,
               textTransform: 'none',
               marginBlock: space.m,
               '& .MuiButton-startIcon, & .MuiButton-endIcon': {
                  color: 'currentColor',
                  '& svg': {
                     fill: 'currentColor',
                     width: size.l,
                     height: size.l,
                  },
               },
            }),

            sizeLarge: {
               fontSize: 18,
               padding: `${space.xs} ${space.l}`,
               marginBlock: space.m,
            },
            sizeSmall: {
               fontSize: size.s,
               padding: `0.2em 1.3em`,
               marginBlock: space.m,
               '& .MuiButton-startIcon, & .MuiButton-endIcon': {
                  '& svg': {
                     width: size.m,
                     height: size.m,
                  },
               },
            },
            outlined: () => ({
               border: `1px solid #CFCFCF`,
            }),
         },
      },
      MuiFormControl: {
         // Customizes all form components
         styleOverrides: {
            root: {
               marginBlock: '0.3em',
               backgroundColor: '#fff',
               borderRadius: space.xs,
               [`& fieldset`]: {
                  borderRadius: space.xs,
               },
            },
         },
      },
      MuiSelect: {
         styleOverrides: {
            select: {
               padding: `1.2em ${space.s}`,
            },
         },
      },
   },
}

export default Theme
